import React from "react";
import { Camera, Send } from "iconoir-react";

interface CommentInputProps {
  comment: string;
  onCommentChange: (value: string) => void;
  onCommentSubmit: () => void;
  showOptionsSheet: boolean;
}

export const CommentInput: React.FC<CommentInputProps> = ({
  comment,
  onCommentChange,
  onCommentSubmit,
  showOptionsSheet,
}) => {
  if (showOptionsSheet) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-60 p-4 bg-[#FBF6F1] inline-flex justify-start items-center gap-2">
      <div className="flex-1 p-3 rounded-md outline outline-1 outline-offset-[-1px] outline-[#D1D1D0] flex justify-between items-center">
        <input
          type="text"
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          placeholder="Viết bình luận..."
          className="flex-1 bg-transparent outline-none text-left text-[#6F6F6B] text-sm font-normal font-sora leading-tight"
        />
        <div
          className="size-6 relative overflow-hidden cursor-pointer"
          onClick={onCommentSubmit}
        >
          <Send className="w-5 h-5 text-[#6F6F6B]" />
        </div>
      </div>
      <div className="size-6 relative overflow-hidden cursor-pointer">
        <Camera className="w-5 h-5 text-[#6F6F6B]" />
      </div>
    </div>
  );
};
